import React from "react";
import NavbarComponent from "../navigation/navbar";
import FooterComponent from "./footer";
import { TopBanner } from "./top_banner";
import { OpenInWindowButton } from "./open_in_window_button";


export const PageLayout = ({ children }) => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="page-layout" >
      {/* <NavbarComponent /> */}
      <TopBanner />
      <OpenInWindowButton />
      <div className="page-layout__content" style={{minHeight: '87vh'}}>{children}</div>
      <footer className="footer">
        © {currentYear} Telemetry LLC. All rights reserved.
      </footer>
    </div>
  );
};
